import { isEmpty, isNil } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { matrixBlockQuery } from '../../content/query-snippets';
import { DeliveryOptionsBlock } from '../delivery-options-block';

const DeliveryOptionsMatrixBlock = ({ restaurant }) => {
  if (!restaurant || isEmpty(restaurant.formattedDeliveryServices) || isNil(restaurant.orderingEnabled)) {
    return null;
  }

  return (
    <DeliveryOptionsBlock
      deliveryServices={restaurant.formattedDeliveryServices}
      orderingEnabled={restaurant.orderingEnabled}
      hasBackgroundDecal={false}
    />
  );
};

DeliveryOptionsMatrixBlock.query = `
  ... on contentMatrix_deliveryOptionsBlock_BlockType {
    ${matrixBlockQuery}
  }
`;

DeliveryOptionsMatrixBlock.propTypes = {
  restaurant: PropTypes.shape({
    formattedDeliveryServices: PropTypes.object,
    orderingEnabled: PropTypes.bool,
  }),
};

DeliveryOptionsMatrixBlock.defaultProps = {
  restaurant: null,
};

export { DeliveryOptionsMatrixBlock };
